import ResourceConversionPanel from 'organisms/Cards/ResourceConversionPanel';

import { clearBlogFilters } from 'layout/Listing/variants/blog/store';

const NoResults = () => (
  <div className="flex w-full flex-col gap-2">
    <ResourceConversionPanel
      variation="basic"
      heading="No Search Results"
      description="There are no results with this criteria. Try changing your search or checking out the featured article above."
      button={{ label: 'Clear Filters', onClick: clearBlogFilters }}
      theme="dark"
    />
  </div>
);

export default NoResults;
